import Modal from '../../../../../commons/Modal/Modal';
import { DashboardProspectsDIRFiltersModalProps } from './DashboardProspectsDIRFiltersModal.types';
import DashboardProspectsDIRFiltersForm from './DashboardProspectsDIRFiltersForm/DashboardProspectsDIRFiltersForm';
import { ModalSizes } from '../../../../../commons/Modal/Modal.types';

export default ({ ...props }: DashboardProspectsDIRFiltersModalProps) => {
  return (
    <Modal 
      className="dashboard__companies-filters" 
      size={ModalSizes.Small} 
      closeOnClickOutside 
      {...props}
    >
      {/* <h2 className="dashboard__companies-filters-title">Filtrer</h2> */}
      <DashboardProspectsDIRFiltersForm closeModal={() => props.setOpen(false)} />
    </Modal>
  );
};
